var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.page ? _c('div', [_c('Banner', {
    attrs: {
      "page": _vm.page
    }
  }), _c('section', {
    staticClass: "profile events-page-wrap clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 kothing-editor-editable text-left",
    staticStyle: {
      "background-color": "transparent !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.page.details)
    }
  })])])])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }